// @flow

import React from 'react';
import loader from 'static/images/image-loader.svg';
import ProgressiveImage from './ProgressiveImage';
import { Dimmer } from 'semantic-ui-react';
import { getImageOrPlaceholder } from 'utils/resources';
import cx from 'classnames';

type Props = {
  resource?: BucketResource,
  className?: string,
  dimmer?: Object,
  dimmerProps?: Object,
};

const resourceAlt = resource => (resource ? resource.name : 'Ressource');

const ResourceImage = ({
  resource,
  className,
  dimmer,
  dimmerProps,
  ...rest
}: Props) => {
  const url = getImageOrPlaceholder(resource);
  const imageClass = cx('ui image', className);

  const innerDimmer =
    dimmer &&
    React.cloneElement(Dimmer.create(dimmer), {
      ...dimmerProps,
    });

  return (
    <div className={imageClass} style={{ overflow: 'visible' }} {...rest}>
      {innerDimmer}
      <ProgressiveImage placeholder={loader} src={url}>
        {src => (
          <img src={src} crossOrigin="Anonymous" alt={resourceAlt(resource)} />
        )}
      </ProgressiveImage>
    </div>
  );
};

export default ResourceImage;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceImage.js